import qs from 'qs';

export const HTTP_STATUS = Object.freeze({
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
});

export const REQUEST_TIMEOUT_MS = 30000;

const repeatParamsSerializer = {
  serialize: (params) =>
    qs.stringify(params, {
      arrayFormat: 'repeat',
      skipNulls: true,
      allowDots: true,
    }),
};

export function mergeAxiosConfig(data, config = {}) {
  return {
    ...config,
    params: data,
    paramsSerializer: repeatParamsSerializer,
  };
}
